import React, { useState, useRef, useEffect, useCallback } from "react"
import { useCompany } from "../contexts/CompanyContext"
import { useConfig } from "../contexts/ConfigContext"
import { useRegister } from "../contexts/RegisterContext"
import { Input } from "antd"
import { useSecureRequest } from "../hooks/useSecureRequest"

const { Search } = Input

function InputSearchItem() {
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const { company } = useCompany()
  const { config } = useConfig()
  const { updateRegister } = useRegister()
  const { securePost } = useSecureRequest()
  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
    }
  }, [])

  const handleItemSearch = useCallback(async (text: string) => {
    setLoading(true)
    const trimmedText = text.trim()
    const path = trimmedText ? '/inventory/item/search-items' : '/inventory/item/get-items'
    try {
      const itemResponse = await securePost(path, {
        company: company.current.uid,
        search: trimmedText,
        module: config.module,
        sellItem: true
      })
      if (itemResponse.status === 200 && Array.isArray(itemResponse.itemList)) {
        updateRegister({ registerList: itemResponse.itemList })
      }
    } catch (error) {
      console.error("Error searching items:", error)
    } finally {
      setLoading(false)
    }
  }, [company, config.module, securePost, updateRegister])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    setSearchValue(val)

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    if (!val.trim()) {
      handleItemSearch("")
    } else {
      searchTimeoutRef.current = setTimeout(() => {
        handleItemSearch(val)
      }, 400)
    }
  }

  const handleSearch = (value: string) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }
    handleItemSearch(value)
  }

  return (
    <Search
      placeholder="Buscar por término"
      allowClear
      value={searchValue}
      onChange={handleChange}
      onSearch={handleSearch}
      loading={loading}
      enterButton
    />
  )
}

export default InputSearchItem